import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { encodeURIComponentWithSpecialSymbols } from 'helpers/url';
import PropTypes from 'prop-types';
import qs from 'query-string';

import { isEmptyCollection, useCategoryState } from '@atlas/core';

import categoryShape from 'common/PropTypes/categoryShape';
import { SkeletonTabs } from 'common/Tabs/Tabs';
import useIsSwipeGrid from 'common/Widgets/Tournament/useIsSwipeGrid';
import EventLoader from 'components/Pages/EventLoader';
import EventSwipeGridLoader from 'components/Pages/EventSwipeGridLoader';

import CategoriesList from './CategoriesList';
import PrematchTopTournamentsList from './PrematchTopTournamentsList';

const PrematchPageViewDefiner = ({ categories }) => {
  const { categoryName } = useParams();
  const { search } = useLocation();
  const parsedQuery = qs.parse(search);
  const primaryCategoryUrlName = encodeURIComponentWithSpecialSymbols(categoryName);
  const primaryTournamentUrlName = encodeURIComponentWithSpecialSymbols(parsedQuery.tournament);
  const topTournamentsCategory = useCategoryState();
  const { initialized, loading, tournaments: topTournaments } = topTournamentsCategory;

  const isSwipeGrid = useIsSwipeGrid();

  if (!initialized && loading) {
    return (
      <div className="category-container">
        <SkeletonTabs />
        <div className="tournament-table">
          <div className="tournament tournament-scroll">
            <div className="tournament-header-info skeleton" />
            <div className="tournament-table-body-container">
              {isSwipeGrid ? <EventSwipeGridLoader /> : <EventLoader />}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isEmptyCollection(topTournaments)) {
    return (
      <CategoriesList
        categories={categories}
        primaryCategoryUrlName={primaryCategoryUrlName}
        primaryTournamentUrlName={primaryTournamentUrlName}
      />
    );
  }

  return (
    <PrematchTopTournamentsList
      categories={categories}
      primaryCategoryUrlName={primaryCategoryUrlName}
      primaryTournamentUrlName={primaryTournamentUrlName}
      search={search}
    />
  );
};

PrematchPageViewDefiner.propTypes = { categories: PropTypes.arrayOf(categoryShape).isRequired };

export default PrematchPageViewDefiner;
